
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"12","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"currentColor","fill-rule":"nonzero"}},[_c('path',{attrs:{"d":"M1.253 5.351h2.12c.031.448.006.898-.075 1.34-.087.494-.23.976-.429 1.437a4.771 4.771 0 01-.759 1.238c-.128.152-.332.31-.613.473a1 1 0 00-.497.865v.48a.724.724 0 001.036.653c.414-.198.734-.39.96-.579a6.536 6.536 0 001.388-1.64c.373-.63.653-1.31.832-2.021A8.828 8.828 0 005.494 5.4V1a1 1 0 00-1-1h-3.24a1 1 0 00-1 1v3.351a1 1 0 001 1zM8.028 1v3.351a1 1 0 001 1h2.121c.032.448.006.898-.075 1.34a6.41 6.41 0 01-.43 1.437 4.771 4.771 0 01-.757 1.238c-.129.152-.333.31-.614.473a1 1 0 00-.497.864v.48a.724.724 0 001.036.653c.414-.197.733-.39.958-.577a6.475 6.475 0 001.388-1.641c.375-.63.656-1.31.834-2.021A8.828 8.828 0 0013.27 5.4V1a1 1 0 00-1-1H9.028a1 1 0 00-1 1z"}})])])
          )
        }
      }
    